import { ShootingType, VirtualTourType } from '../domain/types';

export const shootingTypeLabels: Record<ShootingType, string> = {
  [ShootingType.DIRECT]: 'Diretto',
  [ShootingType.AGENT]: 'Agente',
  [ShootingType.PARTNER]: 'Partner',
};

export const virtualTourTypeLabels: Record<VirtualTourType, string> = {
  [VirtualTourType.MATTERPORT]: 'Matterport',
  [VirtualTourType.FLOORFY]: 'Floorfy',
};
